<div class="progress-bar-wrapper">
  <div class="progress-bar-background">
    <div class="progress-bar" [ngStyle]="{ width: value + '%' }"></div>
  </div>

  <button type="button" class="cancel" (click)="onCancelItem()">
    <app-icon [icon]="icon"></app-icon>
  </button>
</div>
